import './style.scss';
import React from 'react';
import { CurrencyInformation } from '../../../../utils/automaticCurrencyConversion/CurrencyInformation';
import { ShippingCountryDropdown } from './ShippingCountryDropdown';
import { observer } from 'mobx-react-lite';
import {
  closeShippingCurrencyModal,
  closeShippingCurrencyModalWithoutChanges,
  ShippingCurrencyModalState,
} from './state';
import AloModal from '../YogaUI/alo-ui/AloModal';
import { LanguageInformation } from './LanguageSelectionDropdown';

let ShippingCurrencyModal = () => {
  return (
    <AloModal
      wrapperClass={`ShippingCurrencyModal sc-modal`}
      disableBackdropClick={true}
      open={ShippingCurrencyModalState.isOpen}
      showCloseButton={false}
      onClose={() => {
        closeShippingCurrencyModalWithoutChanges();
      }}
    >
      <ModalContent />
    </AloModal>
  );
};

ShippingCurrencyModal = observer(ShippingCurrencyModal);
export { ShippingCurrencyModal };

const ModalContent = observer(() => {
  const {
    countryCurrencyPicker: { disclaimerGlobalE },
  } = window.getSiteSettings();

  return (
    <>
      <ShippingCountryDropdown />
      <LanguageInformation />
      <CurrencyInformation />
      <div className="sc-modal-buttons">
        <button
          className="button-primary"
          onClick={() => {
            closeShippingCurrencyModal();
          }}
        >
          Save
        </button>
      </div>
      <p className="body disclaimer">{disclaimerGlobalE}</p>
      <button className="cancel-button lowercase-button" onClick={closeShippingCurrencyModalWithoutChanges}>
        Cancel
      </button>
    </>
  );
});
